import aktDvk from './aktDvk';

const doc = {
  aktDvk,
};

export default doc;
